import { useState } from "react";

import { CardProps } from "./types";

export function Card({
  theme,
  children,
  padding = 22,
  style = {},
  onClick,
  hover,
  className,
}: CardProps) {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      className={className}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        padding,
        borderRadius: 14,
        background: theme.card,
        border: `1px solid ${theme.rule}`,
        boxShadow:
          hover && hovered
            ? "0 1px 0 rgba(255,255,255,0.5) inset, 0 12px 32px rgba(80,50,30,0.10)"
            : "0 1px 0 rgba(255,255,255,0.5) inset, 0 6px 18px rgba(80,50,30,0.04)",
        transform: hover && hovered ? "translateY(-2px)" : "translateY(0)",
        transition: "box-shadow .18s ease, transform .18s ease",
        cursor: onClick ? "pointer" : "default",
        ...style,
      }}
    >
      {children}
    </div>
  );
}
